/**
 * MarketplaceBreadcrumb
 * Amazon-style breadcrumb trail for marketplace pages.
 * Renders as: Marketplace › {Category} › {Subcategory?} › {Product?}
 */
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function MarketplaceBreadcrumb({ trail = [] }) {
  // trail: [{ label, to? }] — items without `to` render as the current page.
  return (
    <nav
      data-testid="marketplace-breadcrumb"
      aria-label="Breadcrumb"
      className="bg-slate-50 border-b border-slate-200"
    >
      <ol className="max-w-7xl mx-auto px-6 py-2.5 flex items-center flex-wrap gap-1.5 text-[12px]">
        <li>
          <Link
            to="/"
            className="flex items-center gap-1 text-slate-500 hover:text-slate-900 transition-colors p-2 -m-2"
            data-testid="breadcrumb-home"
            aria-label="Home"
          >
            <Home className="w-4 h-4" />
            <span className="sr-only">Home</span>
          </Link>
        </li>
        <li>
          <ChevronRight className="w-3 h-3 text-slate-400" />
        </li>
        <li>
          <Link
            to="/marketplace"
            className="text-slate-500 hover:text-slate-900 font-medium transition-colors"
            data-testid="breadcrumb-marketplace"
          >
            Marketplace
          </Link>
        </li>
        {trail.map((item, i) => (
          <li key={`${item.label}-${i}`} className="flex items-center gap-1.5">
            <ChevronRight className="w-3 h-3 text-slate-400" />
            {item.to ? (
              <Link
                to={item.to}
                className="text-slate-500 hover:text-slate-900 font-medium transition-colors"
                data-testid={`breadcrumb-${item.label.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                className="text-slate-900 font-semibold"
                aria-current="page"
                data-testid={`breadcrumb-current`}
              >
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
